import React, { useEffect, useState } from 'react';

// input format : 2024-06-01T23:54:33.004
// output format : 1 Day : 05 : 50 : 37 hours
const CountdownTimer = ({ timerEnd, difCompareTime }) => {
    const calculateTimeLeft = () => {
        const endTime = new Date(timerEnd);
        let now;

        if (difCompareTime === 'utc') {
            now = new Date(Date.now() + new Date().getTimezoneOffset() * 60000);
        } else {
            now = new Date();
        }

        const difference = endTime - now;

        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        } else {
            timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [timerEnd, difCompareTime]);

    const timerComponents = [];

    if (timeLeft.days > 0) {
        timerComponents.push(
            <span key="days">{timeLeft.days} {timeLeft.days > 1 ? 'Days' : 'Day'}</span>
        );
    }
    if (timeLeft.hours > 0 || timeLeft.days > 0) {
        timerComponents.push(
            <span key="hours">{timeLeft.hours.toString().padStart(2, '0')}</span>
        );
    }
    timerComponents.push(
        <span key="minutes">{timeLeft.minutes.toString().padStart(2, '0')}</span>
    );
    timerComponents.push(
        <span key="seconds">{timeLeft.seconds.toString().padStart(2, '0')} hours</span>
    );

    return (
        <div>
            {timerComponents.length && timerComponents.reduce((prev, curr) => [prev, ' : ', curr])}
        </div>
    );
};

export default CountdownTimer;
